import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TextField from '@/components/textField';

type Props = {
  entity: any;
  errors: any;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
};

const EntityRecord = ({ entity = {}, errors = {}, onNameChange, onDescriptionChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: '8px', p: 1, bgcolor: 'background.paper' }}>
      <Grid container spacing={1}>
        <Grid size={6}>
          <TextField
            label={t('entity.instance.fields.name')}
            value={entity.name}
            required
            error={errors.name}
            onChange={onNameChange}
            type="text"
          />
        </Grid>
        <Grid size={6}>
          <TextField
            label={t('entity.instance.fields.description')}
            value={entity.description || ''}
            multiline
            maxRows={2}
            error={errors.description}
            onChange={onDescriptionChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EntityRecord;
